import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import ContentEditable from './ContentEditable';
import { userShape } from './ThreadItem';

const CommentInput = ({ addComment, authUser = null, threadId }) => {
  const [content, setContent] = React.useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (content === '') {
      toast.error('"content" is not allowed to be empty');
      return;
    }
    addComment({ content, threadId });
    setContent('');
  };

  return (
    <form onSubmit={handleSubmit} className="grid gap-1 mb-6 xl:mb-[40px]">
      <p className="mb-2 block text-base font-medium text-black">
        Give your comment
      </p>
      {authUser ? (
        <>
          <ContentEditable content={content} setContent={setContent} placeholder="Type your content ..." />
          <button type="submit" className="bg-[#F48023] py-3 rounded-md font-black text-white text-sm mt-4 tracking-wide">Send</button>
        </>
      ) : (
        <p className="text-lg">
          Please
          {' '}
          <Link to="/login" className="text-[#1682FD] underline font-medium">login</Link>
          {' '}
          first to give comments
        </p>
      )}
    </form>
  );
};

CommentInput.propTypes = {
  addComment: PropTypes.func.isRequired,
  authUser: PropTypes.shape(userShape),
  threadId: PropTypes.string.isRequired,
};

CommentInput.defaultProps = {
  authUser: null,
};

export default CommentInput;
